import React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import queryClient from "../../utils/queryClient";

const Home = () => {
  const { role } = useAuth();
  const normalizedRole = role?.toLowerCase();

  if (!normalizedRole) {
    localStorage.clear();
    queryClient.clear();
    return <Navigate to="/login" />;
  } else if (normalizedRole === "admin") {
    return <Navigate to="/admindashboard" />;
  } else if (normalizedRole === "supplier") {
    return <Navigate to="/supplierdashboard" />;
  } else {
    // Handle unexpected roles or default
    console.warn("Unexpected role encountered:", role);
    return <Navigate to="/login" />;
  }
};

export default Home;
